import { NOTIFICATION_SUBSCRIPTION_LOCAL_STORAGE_KEY } from '~/composables/utils/product-listing/card-container/constants'
import { useStorage } from '@vueuse/core'
import type { NotificationSubscribedVariantIds } from '~/types/api/bff/web/notification-subscription/remind-me.types'

const EXPIRY_TIME_SUBSCRIPTION_LOCAL_STORAGE_KEY = 30 * 60 * 1000 // 30 minutes as per Luxola

/* To update localStorage values as these are used by web-ui & luxola as a first cache hit.
 * Not relying on localStorage values for SWA because user may have multiple devices and these values won't get updated or invalidated.
 * Better to fetch from server once per session
 */
export const updateLocalStorageNotificationSubscribedIds = (
  userId: string | undefined,
  notificationSubscribedIds: NotificationSubscribedVariantIds
) => {
  if (!userId) return

  const key = `${NOTIFICATION_SUBSCRIPTION_LOCAL_STORAGE_KEY}${userId}`
  const storedData = useStorage<{
    data: number[]
    expiryTime: number
  }>(
    key,
    { data: [], expiryTime: 0 }, // default value
    localStorage
  )

  // To maintain consistency across all platforms, storing subscribed variantIds as number[] in localStorage
  const typeCastedNotificationSubscribedIds =
    notificationSubscribedIds.map(Number)

  const subscriptionData = {
    data: Array.from(
      new Set([
        ...(storedData.value?.data || []),
        ...typeCastedNotificationSubscribedIds,
      ])
    ),
    expiryTime: Date.now() + EXPIRY_TIME_SUBSCRIPTION_LOCAL_STORAGE_KEY,
  }

  storedData.value = subscriptionData
}
